import { useEffect, useState } from 'react';

/**
 * Custom hook to determine if the Next.js app has completed hydrating.
 * This can be used to defer client-side only operations until after rehydration.
 *
 * @returns {boolean} - True if the app has been hydrated, false otherwise.
 */
export const useIsHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  // Effect to set hydrated state after initial mount
  useEffect(() => {
    setIsHydrated(true);
  }, []); // Empty dependency array ensures this runs once after initial render

  return isHydrated;
};
